var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 185.594,
    height: 86.42,
    viewBox: "0 0 185.594 86.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_80",
    x: 2,
    y: 7.776,
    width: 57.366,
    height: 57.366,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_81",
    x: 60.521,
    y: 8.01,
    width: 57.367,
    height: 57.357,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#030000",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_82",
    x: 111.228,
    y: 0,
    width: 74.366,
    height: 74.366,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.957
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "NON-FUNGIBLE_CASTLE",
    x: 0,
    y: 68.42,
    width: 179,
    height: 18,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-68 -370.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(70 378.591)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2, -7.78)",
    filter: "url(#Path_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M89.9,677.866h9.516V651.833s.049-1.55.049-2.34a18.74,18.74,0,0,1,37.344-2.252,19.13,19.13,0,0,1,.137,2.252v28.373h9.321V621.5H89.9Z",
    transform: "translate(-87.9 -613.72)",
    fill: "#fcfaf7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2, -7.78)",
    filter: "url(#Path_81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81-2",
    "data-name": "Path 81",
    d: "M690.1,680.257h9.029V661.224h18.74v-9.565h-18.74a19.109,19.109,0,0,1,.137-2.253,18.739,18.739,0,0,1,37.207,0,19.135,19.135,0,0,1,.136,2.253c0,.136-.009.273-.009.419h9.867V623.9H690.1Z",
    transform: "translate(-629.58 -615.89)",
    fill: "#fcfaf7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2, -7.78)",
    filter: "url(#Path_82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82-2",
    "data-name": "Path 82",
    d: "M1320.388,632.829a18.742,18.742,0,0,1,16.341,9.565h11.837V623.8H1292.2v56.366h56.366V661.134h-12.061a18.741,18.741,0,1,1-16.117-28.3Z",
    transform: "translate(-1172.97 -615.8)",
    fill: "#fcfaf7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 68, 370.82)",
    filter: "url(#NON-FUNGIBLE_CASTLE)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "NON-FUNGIBLE_CASTLE-2",
    "data-name": "NON-FUNGIBLE CASTLE",
    transform: "translate(89 82.42)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Georgia"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -88,
    y: 0
  }, "NON-FUNGIBLE CASTLE"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSplash);
export default __webpack_public_path__ + "static/media/logo-splash.14568f987f03f0bb0d9feb75f36d1835.svg";
export { ForwardRef as ReactComponent };